/*!

=========================================================
* Argon Dashboard React - v1.2.1
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { useEffect, useRef } from "react";
import { Route, Switch, useHistory, useLocation } from "react-router-dom";
import { Container } from "reactstrap";
import chatbot from "evalueserve-chatbot-ui";
import AdminFooter from "../components/Footers/AdminFooter";
import AdminNavbar from "../components/Navbars/AdminNavbar";
import Sidebar from "../components/Sidebar/Sidebar";
import { useCurrentUser } from "../hooks/useCurrentUser";
import routes from "../routes";
import { RouteItem } from "../types.js";
import { checkRoles } from '../utils/checkRoles';
import { getAuth, signOut } from "firebase/auth";
import { useQueryClient } from "react-query";
import { useTokenRefresh } from "../hooks/useTokenRefresh";

const Admin: React.FC = () => {
  useTokenRefresh();
  const { data, isLoading } = useCurrentUser()
  const router = useHistory()
  const mainContent = useRef<HTMLDivElement>(null);
  const location = useLocation();
  const queryClient = useQueryClient()
  
  useEffect(() => {
    if (!data) return
    chatbot({
      loginDetails: { email: data.email, fullName: data.name, accessKey: process.env.REACT_APP_SOCKET_ACCESS_KEY, lobby: '6433a2b2b30ba29f347f4e4a' },
      socketData: { url: process.env.REACT_APP_SOCKET_URL, path: process.env.REACT_APP_SOCKET_PATH }
    });
  }, [data])

  useEffect(() => {
    if (!isLoading && !data) {
      const auth = getAuth();
      signOut(auth);
      localStorage.removeItem('token');
      queryClient.clear();
      router.replace('/auth/login')    }
  }, [data, isLoading, router])

  useEffect(() => {
    document.documentElement.scrollTop = 0;
    if (document.scrollingElement) {
      document.scrollingElement.scrollTop = 0;
    }
    if (mainContent.current) {
      mainContent.current.scrollTop = 0;
    }
  }, [location]);

  const getRoutes = (routes: RouteItem[]) => {
    return routes.map((prop, key) => {
      if (prop.layout === "/admin") {
        if (prop.allow && !checkRoles(data!.roles, prop.allow)) {
          return null;
        }
        return (
          <Route
            path={prop.layout + prop.path}
            component={prop.component}
            key={key}
          />
        );
      } else {
        return null;
      }
    });
  };

  const allowedRoutes: RouteItem[] = routes
    .filter(r => r.isSidebarItem)
    .filter(r => {
      if (!r.allow) {
        return true;
      }
      return checkRoles(data?.roles || [], r.allow)
    })

  if (!data) {
    return null
  }

  return (
    <>
      <Sidebar
        routes={allowedRoutes}
      />
      <div className="main-content" ref={mainContent}>
        <AdminNavbar />
        <Switch>
          {getRoutes(routes)}
        </Switch>
        <Container fluid>
          <AdminFooter />
        </Container>
        <div id="chatwidget-root" style={{ paddingBottom: '50px' }} />
      </div>
    </>
  );
};

export default Admin;
